import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 6h-3v9H6v3h12l4 4V6zm-5 7V2H2v15l4-4h11z"
}), 'QuestionAnswerSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/QuestionAnswerSharp.js
// module id = 5640
// module chunks = 2